var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 3.33329C2.91675 3.10317 3.1033 2.91663 3.33341 2.91663H7.91675C8.14687 2.91663 8.33341 3.10317 8.33341 3.33329V9.58329C8.33341 9.81341 8.14687 9.99996 7.91675 9.99996H3.33341C3.1033 9.99996 2.91675 9.81341 2.91675 9.58329V3.33329Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.4167C11.6667 10.1865 11.8533 10 12.0834 10H16.6667C16.8969 10 17.0834 10.1865 17.0834 10.4167V16.6667C17.0834 16.8968 16.8969 17.0833 16.6667 17.0833H12.0834C11.8533 17.0833 11.6667 16.8968 11.6667 16.6667V10.4167Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.33329C11.6667 3.10317 11.8533 2.91663 12.0834 2.91663H16.6667C16.8969 2.91663 17.0834 3.10317 17.0834 3.33329V6.24996C17.0834 6.48008 16.8969 6.66663 16.6667 6.66663H12.0834C11.8533 6.66663 11.6667 6.48008 11.6667 6.24996V3.33329Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 13.75C2.91675 13.5199 3.1033 13.3334 3.33341 13.3334H8.33341C8.56353 13.3334 8.75008 13.5199 8.75008 13.75V16.6667C8.75008 16.8968 8.56353 17.0834 8.33341 17.0834H3.33341C3.1033 17.0834 2.91675 16.8968 2.91675 16.6667V13.75Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7ddcd47291daf44eb07869395ba38d9c.svg";
export { ForwardRef as ReactComponent };